import { DashboardRow } from 'generated/graphql';

export function resetLayout({ rows }: { rows: DashboardRow[] }) {
  const emptyRows = rows.filter((row) => !row.cells.length);
  const emptyRowIDs = emptyRows.map((row) => row.id);

  emptyRowIDs.forEach((rowId) => {
    rows.splice(
      rows.findIndex((row) => rowId === row.id),
      1,
    );
  });
}
